<template>
  <div class="relative w-full">
    <splide :options="options">
      <splide-slide
        v-for="slide in slides"
        :key="slide.id"
      >
        <vetster-perks-slider-tile
          :perk="slide"
          class="mx-2 my-4"
        />
      </splide-slide>
    </splide>
  </div>
</template>

<script>
// Package "@splidejs/vue-splide" installs the below file, ESLint is wrong.
// eslint-disable-next-line import/no-extraneous-dependencies
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Splide from '@/components/Splide/Splide';
import SplideSlide from '@/components/Splide/SplideSlide';
import VetsterPerksSliderTile from '@/components/VetsterPerksSliderTile';

export default {
  name: 'VetsterPerksSlider',

  components: {
    Splide,
    SplideSlide,
    VetsterPerksSliderTile,
  },

  data() {
    return {
      options: {
        speed: 8000,
        interval: 0,
        keyboard: false,
        pagination: false,
        type: 'loop',
        easing: 'linear',
        rewind: true,
        autoWidth: true,
        autoplay: true,
        pauseOnHover: true,
        arrows: false,
      },
      slides: [
        {
          id: 1,
          title: `${this.$t('vetster-perks.the-perk')}`,
          image: '/images/about/office-dog.jpg',
          description: `${this.$t('vetster-perks.dog-friendly-office')}`,
        },
        {
          id: 2,
          title: `${this.$t('vetster-perks.the-perk')}`,
          image: '/images/about/dog-on-luggage.jpg',
          description: `${this.$t('vetster-perks.vacation-personal-days')}`,
        },
        {
          id: 3,
          title: `${this.$t('vetster-perks.the-perk')}`,
          image: '/images/about/people-collaborating-in-office.jpg',
          description: `${this.$t('vetster-perks.collaborative-supportive-teams')}`,
        },
        {
          id: 4,
          title: `${this.$t('vetster-perks.the-perk')}`,
          image: '/images/about/coworkers-collaborating.jpg',
          description: `${this.$t('vetster-perks.performance-based-compensation')}`,
        },
        {
          id: 5,
          title: `${this.$t('vetster-perks.the-perk')}`,
          image: '/images/about/dog-working-with-owner.jpg',
          description: `${this.$t('vetster-perks.latest-equipment')}`,
        },
        {
          id: 6,
          title: `${this.$t('vetster-perks.the-perk')}`,
          image: '/images/about/cat-on-suitcase.jpg',
          description: `${this.$t('vetster-perks.opportunities-for-travel')}`,
        },
      ],
    };
  },
};
</script>
